<template>
  <div>
    <div class="position-relative">
      <section class="section  section-sm bg-custom-bg-color" style="margin-top: 90px">
        <div class="container p-0">

          <div class="bg-white p-3 rounded-3">

            <!-- 標題樣式與「我的通知」頁一致 -->
            <div class="d-flex align-items-center px-2">
              <h2 class="m-0 font-size-18 font-weight-500 text-custom-text">最新消息</h2>
            </div>

            <div class="mt-3"></div>

            <ListDataLoadingWidget :data="item_data" empty_text="目前沒有最新消息" class="grid-container">
              <template v-slot:default="props">
                <NewsItem :item="props.item"></NewsItem>
                <div class="mt-3"></div>
              </template>
            </ListDataLoadingWidget>

            <!-- 只有一頁（含沒有資料）時不顯示分頁，跟帳單、歷史訂單頁一致 -->
            <template v-if="pageCount > 1">
              <div class="mt-5"></div>
              <div>
                <base-pagination :page-count="pageCount"
                                 :total="total"
                                 :perPage="itemsPerPage"
                                 align="center"
                                 v-model="page"
                                 @input="getNews"
                ></base-pagination>
              </div>
            </template>

          </div>

        </div>
      </section>
    </div>
  </div>
</template>

<script>

import NewsItem from "@/views/components/elements/NewsItem";
import ListDataLoadingWidget from "@/layout/ListDataLoadingWidget";
import * as Api from "@/util/http_api";

export default {
  name: "NewsView",
  components: {
    NewsItem: NewsItem,
    ListDataLoadingWidget: ListDataLoadingWidget,
  },
  props: {
    page: {
      type: Number,
      default: 1,
    },
    itemsPerPage: {
      type: Number,
      default: 8,
    },
  },
  data() {
    return {
      item_data: null,
      pageCount: 0,
      total: 0,
    };
  },
  created() {
    this.getNews();
  },
  methods: {
    async getNews() {
      try {
        this.item_data = null;
        let limit = this.itemsPerPage;
        let offset = (this.page - 1) * limit;
        const result = await Api.getNews(limit, offset);
        this.item_data = result;
        this.total = result.total;
        this.pageCount = Math.ceil(this.total / this.itemsPerPage);
      } catch (e) {
        console.error(e);
      }
    },
  },
}
</script>

<style scoped>
.grid-container {
  display: grid;
  grid-gap: 5px;
}

.grid-item {
  padding: 0px;
}
</style>
